var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 56,
    viewBox: "0 0 47 56",
    width: 47,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#3a3a3a",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 32.394,
    rx: 22.5,
    ry: 22.605
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1491.087 694.228a15.534 15.534 0 1 0 14.58-21.09",
    transform: "translate(-1482.157 -656.812)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.644,
    cy: 32.351,
    r: 2.637
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.007 32.351h-13.184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.797 32.351h-2.637"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24.906 6.273h.879",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1530.289 669.626a27.363 27.363 0 0 0 -4.223-3.729",
    strokeLinecap: "round",
    transform: "translate(-1487.096 -655.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1504.581 663.927v-3.516h-3.516v-3.511a1.757 1.757 0 0 1 1.758-1.758h8.789a1.757 1.757 0 0 1 1.758 1.758v3.516h-3.516v3.516",
    strokeLinecap: "round",
    transform: "translate(-1484.07 -654.138)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.fd8cc159304fea1160915be592050d1b.svg";
export { ForwardRef as ReactComponent };